
export class Constants {
    // public static REST_API_MAIN: string = 'http://localhost:5000';

    public static REST_API_MAIN: string = 'https://api-learn.achatsocial.com';

    // public static REST_API_MAIN: string = 'https://moa-uat-api.achatsocial.com'; // bangwa
    public static REST_API_SW: string = 'https://releep.achatsocial.com:1243'; // bangwa province
}
